import { useCallback, Dispatch, SetStateAction } from 'react';
import { GameState, Tactics, TacticalMentality, AttackingFocus, PassingStyle, DefensiveStyle, TacklingStyle } from '../../../domain/entities';
import { getPlayerTeam } from '../../../services/GameService';

type SetGameState = Dispatch<SetStateAction<GameState | { gameStarted: false; }>>;

interface UseTacticsManagementProps {
    setGameState: SetGameState;
}

export const useTacticsManagement = ({ setGameState }: UseTacticsManagementProps) => {
    const updateTactics = useCallback((
        formation: string, 
        mentality: TacticalMentality, 
        lineup: Tactics['lineup'],
        attackingFocus: AttackingFocus,
        passingStyle: PassingStyle,
        defensiveStyle: DefensiveStyle,
        tacklingStyle: TacklingStyle
    ) => {
        setGameState(prevState => {
            if (!prevState.gameStarted) return prevState;
            const newState = JSON.parse(JSON.stringify(prevState));
            (newState as any).gameStarted = true;
            const playerTeam = getPlayerTeam(newState);
            if (playerTeam) {
                playerTeam.tactics.formation = formation;
                playerTeam.tactics.mentality = mentality;
                playerTeam.tactics.lineup = lineup;
                playerTeam.tactics.attackingFocus = attackingFocus;
                playerTeam.tactics.passingStyle = passingStyle;
                playerTeam.tactics.defensiveStyle = defensiveStyle;
                playerTeam.tactics.tacklingStyle = tacklingStyle;
            }
            return newState;
        });
    }, [setGameState]);

    return {
        updateTactics,
    };
};
